<template>
<div>  
    <el-dialog v-model="isModalVisible" title="Cadastro de nova Tarefa">
        <el-form 
            :model="taskForm"
            label-position="top">
                        
            <el-form-item label="Título">
                <el-input v-model="taskForm.title" />
            </el-form-item>
                
            <el-form-item label="Descrição">
                <QuillEditor v-model="taskForm.description" placeholder="Digite aqui os detalhes da tarefa..." />
            </el-form-item>
            
            <el-form-item label="Cliente">
                <el-select filterable v-model="taskForm.client" placeholder="Selecione o Cliente">
                <el-option
                    v-for="user in activeClients"
                    :key="user.id"
                    :label="user.name"
                    :value="user.id"
                />
                </el-select>
            </el-form-item>
            
            <el-form-item label="Categorias">
                <el-select
                    v-model="taskForm.categories"
                    multiple
                    filterable
                    placeholder="Selecione as categorias"
                >
                    <el-option 
                        v-for="category in categories" 
                        :key="category.id" 
                        :label="category.name" 
                        :value="category.id" 
                    />
                </el-select>
            </el-form-item>
           

            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">                    
                    <el-form-item label="Data de Início">
                        <el-date-picker 
                            v-model="taskForm.startDate" 
                            type="date" 
                            placeholder="Selecione a data de início"
                        />
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">                    
                    <el-form-item label="Prazo de Conclusão">
                        <el-date-picker 
                            v-model="taskForm.deadline" 
                            type="date" 
                            placeholder="Selecione o prazo de conclusão"
                        />
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">                                    
                    <el-form-item label="Urgência">
                        <el-select v-model="taskForm.urgency" placeholder="Selecione a urgência">
                            <el-option label="Baixa" value="0" />
                            <el-option label="Média" value="1" />
                            <el-option label="Alta" value="2" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">                    
                    <el-form-item label="Autor da Tarefa">
                        <el-input v-model="taskForm.author" :disabled="true" />
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">                    
                    <el-form-item label="Pessoa Responsável">
                        <el-select filterable v-model="taskForm.responsible" placeholder="Selecione a pessoa responsável">
                        <el-option
                            v-for="user in activeUsers"
                            :key="user.id"
                            :label="user.name"
                            :value="user.id"
                        />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">                    
                    <el-form-item label="Estágio">
                        <el-select v-model="taskForm.stage" placeholder="Selecione o Estágio">
                            <el-option label="A Fazer" value="0" />
                            <el-option label="Fazendo" value="1" />
                            <el-option label="Pendente" value="2" />
                            <el-option label="Validando" value="3" />
                            <el-option label="Concluída" value="4" />
                            <el-option label="Arquivada" value="5" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>            
        </el-form>
    
        <div>
            <el-button @click="closeModalTask">Cancelar</el-button>
            <el-button type="primary" @click="saveTask">Salvar</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import QuillEditor from './QuillEditor.vue';
import { ElNotification } from 'element-plus';

export default {
    name: 'TaskModalCreate',
    components: {
        QuillEditor
    },
    data() {
        return {
            urlApi: process.env.VUE_APP_API_URL,
            isModalVisible: false,
            taskForm: {              
                title: '',
                description: '',
                client: '',
                categories: [],
                startDate: '',
                deadline: '',                
                urgency: '0',
                author: '',
                author_id: '',
                responsible: '',
                stage: '0',
            },
        }
    },
    computed: {        
        ...mapGetters('taskData', [
            'taskCategories',
            'activeUsers',
            'activeClients',
            'isTaskModalVisible'           
        ]),

        categories() {            
            console.log(this.taskCategories)
            return this.taskCategories;
        }
    },
    methods: {
        
        ...mapActions('taskData', ['closeTaskModal']),
        
        handleCreateTask() {
            this.isModalVisible = true;
        },

        closeModalTask() {
            this.isModalVisible = false;
            this.closeTaskModal();
        },

        async saveTask() {
            this.loading = true;            
            
            try {                
                const response = await this.$store.dispatch('taskData/storeTask', this.taskForm);                

                console.warn('::::::: dados da tarefa cadastrada :::: ', response)


                ElNotification({
                    title: 'Tarefa cadastrada!',
                    message: 'Tarefa cadastrada com sucesso! ',
                    type: 'success'
                });

                this.resetForm();
                this.closeModalTask();  
                
                this.$router.push({
                    'name': 'TaskDetails',
                    'params': {
                        'id': response.id,
                        'slug': response.slug
                    }
                });
                
            } catch (error) {                                
                ElNotification({
                    title: 'Erro!',
                    message: 'Ocorreu um erro inesperado ao processar a solicitação.',
                    type: 'error',
                });                
            }
        },

        resetForm() {
            this.taskForm.title = '';
            this.taskForm.description = '';
            this.taskForm.client = '';
            this.taskForm.categories = [];
            this.taskForm.startDate = '';
            this.taskForm.deadline = '';
            this.taskForm.urgency = '';
            this.taskForm.author = '';
            this.taskForm.author_id = '';
            this.taskForm.responsible = '';
            this.taskForm.stage = '0';            
        },

        dataUserTop() {
            const user = JSON.parse(localStorage.getItem('loggedUser'));
            this.taskForm.author = user.name;
            this.taskForm.author_id = user.id;
        }      
    },
    created() {     
        this.dataUserTop();  
    },
    watch: {
        isTaskModalVisible(newValue) {
            console.log('chegando aqui no create task com o ', newValue)
            this.isModalVisible = newValue;
        }
    }
}
</script>
<style>
.button-float {  
    position: fixed;
    right: 15px;
    top: 50%;
}
.el-tag.el-tag--info {
    --el-tag-text-color: #0b4ac7;
}
</style>
